import styled from 'styled-components';

const MyCarsWrapper = styled.div`
  align-content: center;
  background-color: ${(props) => props.theme.color.neutral.v200};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 30px;
  font-family: 'Brandon Text';

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 40px 100px;
    max-width: 1800px;
    margin: 0 auto;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding: 40px 200px;
    max-width: 1800px;
    margin: 0 auto;
    min-height: 500px;
  }
`;

export { MyCarsWrapper };
